import { render } from "./BlackLayoutForPopUp.vue?vue&type=template&id=7a032a33&scoped=true"
import script from "./BlackLayoutForPopUp.vue?vue&type=script&lang=js"
export * from "./BlackLayoutForPopUp.vue?vue&type=script&lang=js"

import "./BlackLayoutForPopUp.vue?vue&type=style&index=0&id=7a032a33&scoped=true&lang=css"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a032a33"]])

export default __exports__